import { useTranslation } from "react-i18next";
import { Text } from "@/components/ui/Text";
import { Badge } from "@/components/ui/badge";
import { imageFormatLabel } from "@/utils/imageFormatCopy";
import type { CreativeProvenanceProps } from "@/types/creative-library";
export function CreativeProvenance({ provenance }: CreativeProvenanceProps) {
  const { t } = useTranslation("app");
  if (provenance.provenanceState === "unknown")
    return (
      <div
        className="rounded-xl border border-border p-3"
        data-testid="creative-generation-provenance"
      >
        <Text size="xs" color="muted">
          {t("creativeLibrary.provenanceUnknownHint")}
        </Text>
      </div>
    );
  return (
    <div
      className="flex flex-col gap-2 rounded-xl border border-border bg-background p-3"
      data-testid="creative-generation-provenance"
    >
      <Text size="sm">{t("creativeLibrary.createdWith")}</Text>
      <div className="flex flex-wrap gap-1.5">
        {(["brand", "product", "board", "subject"] as const).map((kind) => {
          const identity = provenance[kind];
          return identity ? (
            <Badge
              key={kind}
              variant="outline"
              className="max-w-full whitespace-normal break-words"
            >
              {t(`creativeLibrary.${kind}`)} · {identity.name} · v
              {identity.revision}
            </Badge>
          ) : null;
        })}
        {provenance.formatId && (
          <Badge variant="outline" data-testid="creative-generation-format">
            {imageFormatLabel(t, provenance.formatId)}
          </Badge>
        )}
        {provenance.channel && (
          <Badge variant="outline">
            {t("creativeLibrary.channel")} · {provenance.channel}
          </Badge>
        )}
        <Badge variant="outline">
          {t(
            provenance.intendedUse === "external"
              ? "creativeLibrary.contextExternal"
              : "creativeLibrary.contextInternal",
          )}
        </Badge>
      </div>
      <Text size="xs" color="muted">
        {t("creativeLibrary.provenanceHint")}
      </Text>
    </div>
  );
}
